// Generated file: do not edit.
// See scripts/generateTailwindConfig.ts
import type { Config } from 'tailwindcss';
import plugin from 'tailwindcss/plugin';

const config = {
  content: ['./src/**/*.{js,jsx,ts,tsx}', './public/index.html'],
  darkMode: 'class',
  theme: {
    extend: {
      fontSize: {
        '2xs': ['11px', '12px'],
        '3xs': ['10px', '12px'],
      },
      screens: {
        '2xl': '1366px',
        '3xl': '1920px',
        '4xl': '2560px',
        '5xl': '3200px',
      },
      boxShadow: {
        md: '0px 2px 4px -2px rgba(0, 0, 0, 0.10), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)',
        lg: '0px 4px 6px -4px rgba(0, 0, 0, 0.10), 0px 10px 15px -3px rgba(0, 0, 0, 0.10)',
      },
      keyframes: {
        wave: {
          '0%': {
            transform: 'translateX(-100%)',
          },
          '50%': {
            transform: 'translateX(100%)',
          },
          '100%': {
            transform: 'translateX(100%)',
          },
        },
      },
      animation: {
        wave: 'wave 1.6s linear 0.5s infinite',
      },
      colors: {
        slate: {
          '50': '#f8fafc',
          '100': '#f1f5f9',
          '200': '#e2e8f0',
          '300': '#cbd5e1',
          '400': '#94a3b8',
          '500': '#64748b',
          '600': '#475569',
          '700': '#334155',
          '800': '#191a1e',
          '900': '#0f172a',
          '950': '#020617',
        },
        gray: {
          '50': '#f9fafb',
          '100': '#f3f4f6',
          '200': '#e5e7eb',
          '300': '#d1d5db',
          '400': '#9ca3af',
          '500': '#6b7280',
          '600': '#4b5563',
          '700': '#374151',
          '800': '#1f2937',
          '900': '#111827',
          '950': '#030712',
        },
        zinc: {
          '50': '#fafafa',
          '100': '#f4f4f5',
          '200': '#e4e4e7',
          '300': '#d4d4d8',
          '400': '#a1a1aa',
          '500': '#71717a',
          '600': '#52525b',
          '700': '#3f3f46',
          '800': '#27272a',
          '900': '#18181b',
          '950': '#09090b',
        },
        neutral: {
          '0': '#f0f0f0',
          '50': '#d4d4d8',
          '100': '#b9b9c0',
          '200': '#929699',
          '300': '#7e8388',
          '400': '#636b73',
          '500': '#3c4046',
          '600': '#242529',
          '700': '#1c1e20',
          '800': '#191a1e',
          '900': '#131619',
          '950': '#080809',
          '1000': '#000000',
        },
        stone: {
          '50': '#fafaf9',
          '100': '#f5f5f4',
          '200': '#e7e5e4',
          '300': '#d6d3d1',
          '400': '#a8a29e',
          '500': '#78716c',
          '600': '#57534e',
          '700': '#44403c',
          '800': '#292524',
          '900': '#1c1917',
          '950': '#0c0a09',
        },
        red: {
          '50': '#fef2f2',
          '100': '#fee2e2',
          '200': '#fecaca',
          '300': '#fca5a5',
          '400': '#f87171',
          '500': '#ff385e',
          '600': '#dc2626',
          '700': '#b91c1c',
          '800': '#991b1b',
          '900': '#7f1d1d',
          '950': '#450a0a',
        },
        orange: {
          '50': '#fff7ed',
          '100': '#ffedd5',
          '200': '#fed7aa',
          '300': '#fdba74',
          '400': '#fb923c',
          '500': '#f97316',
          '600': '#ea580c',
          '700': '#c2410c',
          '800': '#9a3412',
          '900': '#7c2d12',
          '950': '#431407',
        },
        amber: {
          '50': '#fffbeb',
          '100': '#fef3c7',
          '200': '#fde68a',
          '300': '#fcd34d',
          '400': '#fbbf24',
          '500': '#f59e0b',
          '600': '#d97706',
          '700': '#b45309',
          '800': '#92400e',
          '900': '#78350f',
          '950': '#451a03',
        },
        yellow: {
          '50': '#fefce8',
          '100': '#fef9c3',
          '200': '#fef08a',
          '300': '#fde047',
          '400': '#facc15',
          '500': '#eab308',
          '600': '#ca8a04',
          '700': '#a16207',
          '800': '#854d0e',
          '900': '#713f12',
          '950': '#422006',
        },
        lime: {
          '50': '#f7fee7',
          '100': '#ecfccb',
          '200': '#d9f99d',
          '300': '#bef264',
          '400': '#a3e635',
          '500': '#84cc16',
          '600': '#65a30d',
          '700': '#4d7c0f',
          '800': '#3f6212',
          '900': '#365314',
          '950': '#1a2e05',
        },
        green: {
          '50': '#f0fdf4',
          '100': '#dcfce7',
          '200': '#bbf7d0',
          '300': '#86efac',
          '400': '#4ade80',
          '500': '#18ff90',
          '600': '#16a34a',
          '700': '#15803d',
          '800': '#166534',
          '900': '#14532d',
          '950': '#052e16',
        },
        emerald: {
          '50': '#ecfdf5',
          '100': '#d1fae5',
          '200': '#a7f3d0',
          '300': '#6ee7b7',
          '400': '#34d399',
          '500': '#10b981',
          '600': '#059669',
          '700': '#047857',
          '800': '#065f46',
          '900': '#064e3b',
          '950': '#022c22',
        },
        teal: {
          '50': '#f0fdfa',
          '100': '#ccfbf1',
          '200': '#99f6e4',
          '300': '#5eead4',
          '400': '#2dd4bf',
          '500': '#14b8a6',
          '600': '#0d9488',
          '700': '#0f766e',
          '800': '#115e59',
          '900': '#134e4a',
          '950': '#042f2e',
        },
        cyan: {
          '50': '#ecfeff',
          '100': '#cffafe',
          '200': '#a5f3fc',
          '300': '#67e8f9',
          '400': '#22d3ee',
          '500': '#06b6d4',
          '600': '#0891b2',
          '700': '#0e7490',
          '800': '#155e75',
          '900': '#164e63',
          '950': '#083344',
        },
        sky: {
          '50': '#f0f9ff',
          '100': '#e0f2fe',
          '200': '#bae6fd',
          '300': '#7dd3fc',
          '400': '#38bdf8',
          '500': '#0ea5e9',
          '600': '#0284c7',
          '700': '#0369a1',
          '800': '#075985',
          '900': '#0c4a6e',
          '950': '#082f49',
        },
        blue: {
          '50': '#eff6ff',
          '100': '#dbeafe',
          '200': '#bfdbfe',
          '300': '#93c5fd',
          '400': '#60a5fa',
          '500': '#3b82f6',
          '600': '#2563eb',
          '700': '#1d4ed8',
          '800': '#1e40af',
          '900': '#1e3a8a',
          '950': '#172554',
        },
        indigo: {
          '50': '#eef2ff',
          '100': '#e0e7ff',
          '200': '#c7d2fe',
          '300': '#a5b4fc',
          '400': '#818cf8',
          '500': '#6366f1',
          '600': '#4f46e5',
          '700': '#4338ca',
          '800': '#3730a3',
          '900': '#312e81',
          '950': '#1e1b4b',
        },
        violet: {
          '50': '#f5f3ff',
          '100': '#ede9fe',
          '200': '#ddd6fe',
          '300': '#c4b5fd',
          '400': '#a78bfa',
          '500': '#8b5cf6',
          '600': '#7c3aed',
          '700': '#6d28d9',
          '800': '#5b21b6',
          '900': '#4c1d95',
          '950': '#2e1065',
        },
        purple: {
          '50': '#faf5ff',
          '100': '#f3e8ff',
          '200': '#e9d5ff',
          '300': '#d8b4fe',
          '400': '#c084fc',
          '500': '#a855f7',
          '600': '#9333ea',
          '700': '#7e22ce',
          '800': '#6b21a8',
          '900': '#581c87',
          '950': '#3b0764',
        },
        fuchsia: {
          '50': '#fdf4ff',
          '100': '#fae8ff',
          '200': '#f5d0fe',
          '300': '#f0abfc',
          '400': '#e879f9',
          '500': '#d946ef',
          '600': '#c026d3',
          '700': '#a21caf',
          '800': '#86198f',
          '900': '#701a75',
          '950': '#4a044e',
        },
        pink: {
          '50': '#fdf2f8',
          '100': '#fce7f3',
          '200': '#fbcfe8',
          '300': '#f9a8d4',
          '400': '#f472b6',
          '500': '#ec4899',
          '600': '#db2777',
          '700': '#be185d',
          '800': '#9d174d',
          '900': '#831843',
          '950': '#500724',
        },
        rose: {
          '50': '#fff1f2',
          '100': '#ffe4e6',
          '200': '#fecdd3',
          '300': '#fda4af',
          '400': '#fb7185',
          '500': '#f43f5e',
          '600': '#e11d48',
          '700': '#be123c',
          '800': '#9f1239',
          '900': '#881337',
          '950': '#4c0519',
        },
        white: '#ffffff',
        black: '#000000',
        backgroundBase: 'var(--background-backgroundBase)',
        backgroundPrimary: 'var(--background-backgroundPrimary)',
        backgroundSecondary: 'var(--background-backgroundSecondary)',
        backgroundTertiary: 'var(--background-backgroundTertiary)',
        backgroundInversePrimary: 'var(--background-backgroundInversePrimary)',
        backgroundInverseSecondary: 'var(--background-backgroundInverseSecondary)',
        backgroundInverseTertiary: 'var(--background-backgroundInverseTertiary)',
        backgroundHover: 'var(--background-backgroundHover)',
        backgroundHoverOverlay: 'var(--background-backgroundHoverOverlay)',
        backgroundInverseHoverOverlay: 'var(--background-backgroundInverseHoverOverlay)',
        backgroundRed: 'var(--background-backgroundRed)',
        backgroundOrange: 'var(--background-backgroundOrange)',
        backgroundYellow: 'var(--background-backgroundYellow)',
        backgroundAmber: 'var(--background-backgroundAmber)',
        backgroundLime: 'var(--background-backgroundLime)',
        backgroundEmerald: 'var(--background-backgroundEmerald)',
        backgroundGreen: 'var(--background-backgroundGreen)',
        backgroundTeal: 'var(--background-backgroundTeal)',
        backgroundCyan: 'var(--background-backgroundCyan)',
        backgroundSky: 'var(--background-backgroundSky)',
        backgroundBlue: 'var(--background-backgroundBlue)',
        backgroundIndigo: 'var(--background-backgroundIndigo)',
        backgroundViolet: 'var(--background-backgroundViolet)',
        backgroundPurple: 'var(--background-backgroundPurple)',
        backgroundFuchsia: 'var(--background-backgroundFuchsia)',
        backgroundPink: 'var(--background-backgroundPink)',
        backgroundRose: 'var(--background-backgroundRose)',
        backgroundZinc: 'var(--background-backgroundZinc)',
        contentPrimary: 'var(--content-contentPrimary)',
        contentSecondary: 'var(--content-contentSecondary)',
        contentTertiary: 'var(--content-contentTertiary)',
        contentInversePrimary: 'var(--content-contentInversePrimary)',
        contentInverseSecondary: 'var(--content-contentInverseSecondary)',
        contentInverseTertiary: 'var(--content-contentInverseTertiary)',
        contentGreen: 'var(--content-contentGreen)',
        contentRed: 'var(--content-contentRed)',
        contentHoverOverlay: 'var(--content-contentHoverOverlay)',
        contentOrange: 'var(--content-contentOrange)',
        contentYellow: 'var(--content-contentYellow)',
        contentAmber: 'var(--content-contentAmber)',
        contentLime: 'var(--content-contentLime)',
        contentEmerald: 'var(--content-contentEmerald)',
        contentTeal: 'var(--content-contentTeal)',
        contentCyan: 'var(--content-contentCyan)',
        contentSky: 'var(--content-contentSky)',
        contentBlue: 'var(--content-contentBlue)',
        contentIndigo: 'var(--content-contentIndigo)',
        contentViolet: 'var(--content-contentViolet)',
        contentPurple: 'var(--content-contentPurple)',
        contentFuchsia: 'var(--content-contentFuchsia)',
        contentPink: 'var(--content-contentPink)',
        contentRose: 'var(--content-contentRose)',
        contentZinc: 'var(--content-contentZinc)',
        borderPrimary: 'var(--border-borderPrimary)',
        borderSecondary: 'var(--border-borderSecondary)',
        borderTertiary: 'var(--border-borderTertiary)',
        borderInversePrimary: 'var(--border-borderInversePrimary)',
        borderInverseSecondary: 'var(--border-borderInverseSecondary)',
        borderInverseTertiary: 'var(--border-borderInverseTertiary)',
        borderHoverOverlay: 'var(--border-borderHoverOverlay)',
        borderInverseHoverOverlay: 'var(--border-borderInverseHoverOverlay)',
        borderError: 'var(--border-borderError)',
        borderWarning: 'var(--border-borderWarning)',
        borderSuccess: 'var(--border-borderSuccess)',
        borderInfo: 'var(--border-borderInfo)',
      },
    },
  },
  plugins: [
    plugin(function ({ addComponents }) {
      addComponents({
        '.scrollbar-hide': {
          '&::-webkit-scrollbar-thumb': {
            background: 'transparent',
          },
        },
        '.scrollbar-none': {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
      });
    }),
    plugin(function ({ addVariant }) {
      addVariant('has-hover', '@media (hover: hover)');
    }),
    plugin(function ({ addBase }) {
      addBase({
        ':root': {
          '--color-slate-50': '#f8fafc',
          '--color-slate-100': '#f1f5f9',
          '--color-slate-200': '#e2e8f0',
          '--color-slate-300': '#cbd5e1',
          '--color-slate-400': '#94a3b8',
          '--color-slate-500': '#64748b',
          '--color-slate-600': '#475569',
          '--color-slate-700': '#334155',
          '--color-slate-800': '#191a1e',
          '--color-slate-900': '#0f172a',
          '--color-slate-950': '#020617',
          '--color-gray-50': '#f9fafb',
          '--color-gray-100': '#f3f4f6',
          '--color-gray-200': '#e5e7eb',
          '--color-gray-300': '#d1d5db',
          '--color-gray-400': '#9ca3af',
          '--color-gray-500': '#6b7280',
          '--color-gray-600': '#4b5563',
          '--color-gray-700': '#374151',
          '--color-gray-800': '#1f2937',
          '--color-gray-900': '#111827',
          '--color-gray-950': '#030712',
          '--color-zinc-50': '#fafafa',
          '--color-zinc-100': '#f4f4f5',
          '--color-zinc-200': '#e4e4e7',
          '--color-zinc-300': '#d4d4d8',
          '--color-zinc-400': '#a1a1aa',
          '--color-zinc-500': '#71717a',
          '--color-zinc-600': '#52525b',
          '--color-zinc-700': '#3f3f46',
          '--color-zinc-800': '#27272a',
          '--color-zinc-900': '#18181b',
          '--color-zinc-950': '#09090b',
          '--color-neutral-0': '#f0f0f0',
          '--color-neutral-50': '#d4d4d8',
          '--color-neutral-100': '#b9b9c0',
          '--color-neutral-200': '#929699',
          '--color-neutral-300': '#7e8388',
          '--color-neutral-400': '#636b73',
          '--color-neutral-500': '#3c4046',
          '--color-neutral-600': '#242529',
          '--color-neutral-700': '#1c1e20',
          '--color-neutral-800': '#191a1e',
          '--color-neutral-900': '#131619',
          '--color-neutral-950': '#080809',
          '--color-neutral-1000': '#000000',
          '--color-stone-50': '#fafaf9',
          '--color-stone-100': '#f5f5f4',
          '--color-stone-200': '#e7e5e4',
          '--color-stone-300': '#d6d3d1',
          '--color-stone-400': '#a8a29e',
          '--color-stone-500': '#78716c',
          '--color-stone-600': '#57534e',
          '--color-stone-700': '#44403c',
          '--color-stone-800': '#292524',
          '--color-stone-900': '#1c1917',
          '--color-stone-950': '#0c0a09',
          '--color-red-50': '#fef2f2',
          '--color-red-100': '#fee2e2',
          '--color-red-200': '#fecaca',
          '--color-red-300': '#fca5a5',
          '--color-red-400': '#f87171',
          '--color-red-500': '#ff385e',
          '--color-red-600': '#dc2626',
          '--color-red-700': '#b91c1c',
          '--color-red-800': '#991b1b',
          '--color-red-900': '#7f1d1d',
          '--color-red-950': '#450a0a',
          '--color-orange-50': '#fff7ed',
          '--color-orange-100': '#ffedd5',
          '--color-orange-200': '#fed7aa',
          '--color-orange-300': '#fdba74',
          '--color-orange-400': '#fb923c',
          '--color-orange-500': '#f97316',
          '--color-orange-600': '#ea580c',
          '--color-orange-700': '#c2410c',
          '--color-orange-800': '#9a3412',
          '--color-orange-900': '#7c2d12',
          '--color-orange-950': '#431407',
          '--color-amber-50': '#fffbeb',
          '--color-amber-100': '#fef3c7',
          '--color-amber-200': '#fde68a',
          '--color-amber-300': '#fcd34d',
          '--color-amber-400': '#fbbf24',
          '--color-amber-500': '#f59e0b',
          '--color-amber-600': '#d97706',
          '--color-amber-700': '#b45309',
          '--color-amber-800': '#92400e',
          '--color-amber-900': '#78350f',
          '--color-amber-950': '#451a03',
          '--color-yellow-50': '#fefce8',
          '--color-yellow-100': '#fef9c3',
          '--color-yellow-200': '#fef08a',
          '--color-yellow-300': '#fde047',
          '--color-yellow-400': '#facc15',
          '--color-yellow-500': '#eab308',
          '--color-yellow-600': '#ca8a04',
          '--color-yellow-700': '#a16207',
          '--color-yellow-800': '#854d0e',
          '--color-yellow-900': '#713f12',
          '--color-yellow-950': '#422006',
          '--color-lime-50': '#f7fee7',
          '--color-lime-100': '#ecfccb',
          '--color-lime-200': '#d9f99d',
          '--color-lime-300': '#bef264',
          '--color-lime-400': '#a3e635',
          '--color-lime-500': '#84cc16',
          '--color-lime-600': '#65a30d',
          '--color-lime-700': '#4d7c0f',
          '--color-lime-800': '#3f6212',
          '--color-lime-900': '#365314',
          '--color-lime-950': '#1a2e05',
          '--color-green-50': '#f0fdf4',
          '--color-green-100': '#dcfce7',
          '--color-green-200': '#bbf7d0',
          '--color-green-300': '#86efac',
          '--color-green-400': '#4ade80',
          '--color-green-500': '#18ff90',
          '--color-green-600': '#16a34a',
          '--color-green-700': '#15803d',
          '--color-green-800': '#166534',
          '--color-green-900': '#14532d',
          '--color-green-950': '#052e16',
          '--color-emerald-50': '#ecfdf5',
          '--color-emerald-100': '#d1fae5',
          '--color-emerald-200': '#a7f3d0',
          '--color-emerald-300': '#6ee7b7',
          '--color-emerald-400': '#34d399',
          '--color-emerald-500': '#10b981',
          '--color-emerald-600': '#059669',
          '--color-emerald-700': '#047857',
          '--color-emerald-800': '#065f46',
          '--color-emerald-900': '#064e3b',
          '--color-emerald-950': '#022c22',
          '--color-teal-50': '#f0fdfa',
          '--color-teal-100': '#ccfbf1',
          '--color-teal-200': '#99f6e4',
          '--color-teal-300': '#5eead4',
          '--color-teal-400': '#2dd4bf',
          '--color-teal-500': '#14b8a6',
          '--color-teal-600': '#0d9488',
          '--color-teal-700': '#0f766e',
          '--color-teal-800': '#115e59',
          '--color-teal-900': '#134e4a',
          '--color-teal-950': '#042f2e',
          '--color-cyan-50': '#ecfeff',
          '--color-cyan-100': '#cffafe',
          '--color-cyan-200': '#a5f3fc',
          '--color-cyan-300': '#67e8f9',
          '--color-cyan-400': '#22d3ee',
          '--color-cyan-500': '#06b6d4',
          '--color-cyan-600': '#0891b2',
          '--color-cyan-700': '#0e7490',
          '--color-cyan-800': '#155e75',
          '--color-cyan-900': '#164e63',
          '--color-cyan-950': '#083344',
          '--color-sky-50': '#f0f9ff',
          '--color-sky-100': '#e0f2fe',
          '--color-sky-200': '#bae6fd',
          '--color-sky-300': '#7dd3fc',
          '--color-sky-400': '#38bdf8',
          '--color-sky-500': '#0ea5e9',
          '--color-sky-600': '#0284c7',
          '--color-sky-700': '#0369a1',
          '--color-sky-800': '#075985',
          '--color-sky-900': '#0c4a6e',
          '--color-sky-950': '#082f49',
          '--color-blue-50': '#eff6ff',
          '--color-blue-100': '#dbeafe',
          '--color-blue-200': '#bfdbfe',
          '--color-blue-300': '#93c5fd',
          '--color-blue-400': '#60a5fa',
          '--color-blue-500': '#3b82f6',
          '--color-blue-600': '#2563eb',
          '--color-blue-700': '#1d4ed8',
          '--color-blue-800': '#1e40af',
          '--color-blue-900': '#1e3a8a',
          '--color-blue-950': '#172554',
          '--color-indigo-50': '#eef2ff',
          '--color-indigo-100': '#e0e7ff',
          '--color-indigo-200': '#c7d2fe',
          '--color-indigo-300': '#a5b4fc',
          '--color-indigo-400': '#818cf8',
          '--color-indigo-500': '#6366f1',
          '--color-indigo-600': '#4f46e5',
          '--color-indigo-700': '#4338ca',
          '--color-indigo-800': '#3730a3',
          '--color-indigo-900': '#312e81',
          '--color-indigo-950': '#1e1b4b',
          '--color-violet-50': '#f5f3ff',
          '--color-violet-100': '#ede9fe',
          '--color-violet-200': '#ddd6fe',
          '--color-violet-300': '#c4b5fd',
          '--color-violet-400': '#a78bfa',
          '--color-violet-500': '#8b5cf6',
          '--color-violet-600': '#7c3aed',
          '--color-violet-700': '#6d28d9',
          '--color-violet-800': '#5b21b6',
          '--color-violet-900': '#4c1d95',
          '--color-violet-950': '#2e1065',
          '--color-purple-50': '#faf5ff',
          '--color-purple-100': '#f3e8ff',
          '--color-purple-200': '#e9d5ff',
          '--color-purple-300': '#d8b4fe',
          '--color-purple-400': '#c084fc',
          '--color-purple-500': '#a855f7',
          '--color-purple-600': '#9333ea',
          '--color-purple-700': '#7e22ce',
          '--color-purple-800': '#6b21a8',
          '--color-purple-900': '#581c87',
          '--color-purple-950': '#3b0764',
          '--color-fuchsia-50': '#fdf4ff',
          '--color-fuchsia-100': '#fae8ff',
          '--color-fuchsia-200': '#f5d0fe',
          '--color-fuchsia-300': '#f0abfc',
          '--color-fuchsia-400': '#e879f9',
          '--color-fuchsia-500': '#d946ef',
          '--color-fuchsia-600': '#c026d3',
          '--color-fuchsia-700': '#a21caf',
          '--color-fuchsia-800': '#86198f',
          '--color-fuchsia-900': '#701a75',
          '--color-fuchsia-950': '#4a044e',
          '--color-pink-50': '#fdf2f8',
          '--color-pink-100': '#fce7f3',
          '--color-pink-200': '#fbcfe8',
          '--color-pink-300': '#f9a8d4',
          '--color-pink-400': '#f472b6',
          '--color-pink-500': '#ec4899',
          '--color-pink-600': '#db2777',
          '--color-pink-700': '#be185d',
          '--color-pink-800': '#9d174d',
          '--color-pink-900': '#831843',
          '--color-pink-950': '#500724',
          '--color-rose-50': '#fff1f2',
          '--color-rose-100': '#ffe4e6',
          '--color-rose-200': '#fecdd3',
          '--color-rose-300': '#fda4af',
          '--color-rose-400': '#fb7185',
          '--color-rose-500': '#f43f5e',
          '--color-rose-600': '#e11d48',
          '--color-rose-700': '#be123c',
          '--color-rose-800': '#9f1239',
          '--color-rose-900': '#881337',
          '--color-rose-950': '#4c0519',
          '--color-white': '#ffffff',
          '--color-black': '#000000',
          '--content-contentPrimary': 'var(--color-zinc-950)',
          '--content-contentSecondary': 'var(--color-zinc-500)',
          '--content-contentTertiary': 'var(--color-zinc-700)',
          '--content-contentInversePrimary': 'var(--color-white)',
          '--content-contentInverseSecondary': 'var(--color-zinc-400)',
          '--content-contentInverseTertiary': 'var(--color-zinc-500)',
          '--content-contentGreen': 'var(--color-green-500)',
          '--content-contentRed': 'var(--color-red-500)',
          '--content-contentHoverOverlay': '#ffffff',
          '--content-contentOrange': 'var(--color-orange-700)',
          '--content-contentYellow': 'var(--color-yellow-700)',
          '--content-contentAmber': 'var(--color-amber-700)',
          '--content-contentLime': 'var(--color-lime-700)',
          '--content-contentEmerald': 'var(--color-emerald-700)',
          '--content-contentTeal': 'var(--color-teal-700)',
          '--content-contentCyan': 'var(--color-cyan-700)',
          '--content-contentSky': 'var(--color-sky-700)',
          '--content-contentBlue': 'var(--color-blue-500)',
          '--content-contentIndigo': 'var(--color-indigo-700)',
          '--content-contentViolet': 'var(--color-violet-700)',
          '--content-contentPurple': 'var(--color-purple-700)',
          '--content-contentFuchsia': 'var(--color-fuchsia-700)',
          '--content-contentPink': 'var(--color-pink-700)',
          '--content-contentRose': 'var(--color-rose-700)',
          '--content-contentZinc': 'var(--color-zinc-700)',
          '--background-backgroundBase': 'var(--color-white)',
          '--background-backgroundPrimary': 'var(--color-zinc-50)',
          '--background-backgroundSecondary': 'var(--color-zinc-300)',
          '--background-backgroundTertiary': 'var(--color-zinc-100)',
          '--background-backgroundInversePrimary': 'var(--color-neutral-950)',
          '--background-backgroundInverseSecondary': 'var(--color-neutral-900)',
          '--background-backgroundInverseTertiary': 'var(--color-neutral-600)',
          '--background-backgroundHover': 'var(--color-blue-500)',
          '--background-backgroundHoverOverlay': 'rgba(0, 0, 0, 0.025)',
          '--background-backgroundInverseHoverOverlay': 'rgba(255, 255, 255, 0.05)',
          '--background-backgroundRed': 'var(--color-red-500)',
          '--background-backgroundOrange': 'var(--color-orange-100)',
          '--background-backgroundYellow': 'var(--color-yellow-100)',
          '--background-backgroundAmber': 'var(--color-amber-100)',
          '--background-backgroundLime': 'var(--color-lime-100)',
          '--background-backgroundEmerald': 'var(--color-emerald-100)',
          '--background-backgroundGreen': 'var(--color-green-500)',
          '--background-backgroundTeal': 'var(--color-teal-100)',
          '--background-backgroundCyan': 'var(--color-cyan-100)',
          '--background-backgroundSky': 'var(--color-sky-100)',
          '--background-backgroundBlue': 'var(--color-blue-100)',
          '--background-backgroundIndigo': 'var(--color-indigo-100)',
          '--background-backgroundViolet': 'var(--color-violet-100)',
          '--background-backgroundPurple': 'var(--color-purple-100)',
          '--background-backgroundFuchsia': 'var(--color-fuchsia-100)',
          '--background-backgroundPink': 'var(--color-pink-100)',
          '--background-backgroundRose': 'var(--color-rose-100)',
          '--background-backgroundZinc': 'var(--color-zinc-100)',
          '--border-borderPrimary': 'var(--color-zinc-200)',
          '--border-borderSecondary': 'var(--color-zinc-100)',
          '--border-borderTertiary': 'var(--color-zinc-50)',
          '--border-borderInversePrimary': 'var(--color-zinc-700)',
          '--border-borderInverseSecondary': 'var(--color-zinc-800)',
          '--border-borderInverseTertiary': 'var(--color-zinc-950)',
          '--border-borderHoverOverlay': 'rgba(0, 0, 0, 0.2)',
          '--border-borderInverseHoverOverlay': 'rgba(255, 255, 255, 0.1)',
          '--border-borderError': 'var(--color-red-500)',
          '--border-borderWarning': 'var(--color-amber-500)',
          '--border-borderSuccess': 'var(--color-green-500)',
          '--border-borderInfo': 'var(--color-blue-500)',
        },
        '.dark': {
          '--content-contentPrimary': 'var(--color-neutral-0)',
          '--content-contentSecondary': 'var(--color-neutral-400)',
          '--content-contentTertiary': 'var(--color-neutral-100)',
          '--content-contentInversePrimary': 'var(--color-neutral-900)',
          '--content-contentInverseSecondary': 'var(--color-neutral-500)',
          '--content-contentInverseTertiary': 'var(--color-neutral-400)',
          '--content-contentGreen': 'var(--color-green-500)',
          '--content-contentRed': 'var(--color-red-500)',
          '--content-contentHoverOverlay': 'rgba(255, 255, 255, 0.3)',
          '--content-contentOrange': 'var(--color-orange-400)',
          '--content-contentYellow': 'var(--color-yellow-400)',
          '--content-contentAmber': 'var(--color-amber-400)',
          '--content-contentLime': 'var(--color-lime-400)',
          '--content-contentEmerald': 'var(--color-emerald-400)',
          '--content-contentTeal': 'var(--color-teal-400)',
          '--content-contentCyan': 'var(--color-cyan-400)',
          '--content-contentSky': 'var(--color-sky-400)',
          '--content-contentBlue': 'var(--color-blue-500)',
          '--content-contentIndigo': 'var(--color-indigo-400)',
          '--content-contentViolet': 'var(--color-violet-400)',
          '--content-contentPurple': 'var(--color-purple-400)',
          '--content-contentFuchsia': 'var(--color-fuchsia-400)',
          '--content-contentPink': 'var(--color-pink-400)',
          '--content-contentRose': 'var(--color-rose-400)',
          '--content-contentZinc': 'var(--color-zinc-400)',
          '--background-backgroundBase': 'var(--color-neutral-950)',
          '--background-backgroundPrimary': 'var(--color-neutral-900)',
          '--background-backgroundSecondary': 'var(--color-neutral-700)',
          '--background-backgroundTertiary': 'var(--color-neutral-600)',
          '--background-backgroundInversePrimary': 'var(--color-neutral-500)',
          '--background-backgroundInverseSecondary': 'var(--color-zinc-400)',
          '--background-backgroundInverseTertiary': 'var(--color-zinc-200)',
          '--background-backgroundHover': 'var(--color-blue-500)',
          '--background-backgroundHoverOverlay': 'rgba(255, 255, 255, 0.05)',
          '--background-backgroundInverseHoverOverlay': 'rgba(0, 0, 0, 0.025)',
          '--background-backgroundRed': 'var(--color-red-500)',
          '--background-backgroundOrange': 'var(--color-orange-950)',
          '--background-backgroundYellow': 'var(--color-yellow-950)',
          '--background-backgroundAmber': 'var(--color-amber-950)',
          '--background-backgroundLime': 'var(--color-lime-950)',
          '--background-backgroundEmerald': 'var(--color-emerald-950)',
          '--background-backgroundGreen': 'var(--color-green-500)',
          '--background-backgroundTeal': 'var(--color-teal-950)',
          '--background-backgroundCyan': 'var(--color-cyan-950)',
          '--background-backgroundSky': 'var(--color-sky-950)',
          '--background-backgroundBlue': 'var(--color-blue-500)',
          '--background-backgroundIndigo': 'var(--color-indigo-950)',
          '--background-backgroundViolet': 'var(--color-violet-950)',
          '--background-backgroundPurple': 'var(--color-purple-950)',
          '--background-backgroundFuchsia': 'var(--color-fuchsia-950)',
          '--background-backgroundPink': 'var(--color-pink-950)',
          '--background-backgroundRose': 'var(--color-rose-950)',
          '--background-backgroundZinc': 'var(--color-zinc-800)',
          '--border-borderPrimary': 'var(--color-neutral-700)',
          '--border-borderSecondary': 'var(--color-neutral-800)',
          '--border-borderTertiary': 'var(--color-neutral-900)',
          '--border-borderInversePrimary': 'var(--color-zinc-700)',
          '--border-borderInverseSecondary': 'var(--color-zinc-800)',
          '--border-borderInverseTertiary': 'var(--color-zinc-700)',
          '--border-borderHoverOverlay': 'rgba(255, 255, 255, 0.1)',
          '--border-borderInverseHoverOverlay': 'rgba(0, 0, 0, 0.2)',
          '--border-borderError': 'var(--color-red-500)',
          '--border-borderWarning': 'var(--color-amber-500)',
          '--border-borderSuccess': 'var(--color-green-500)',
          '--border-borderInfo': 'var(--color-blue-500)',
        },
      });
    }),
  ],
} as const satisfies Config;

export default config;
